import type { WorldEventHandler } from './types';

const handlers = new Map<string, WorldEventHandler>();

/** Register a handler. Replaces any previous handler for the same eventId. */
export function registerWorldEventHandler(h: WorldEventHandler): void {
  handlers.set(h.eventId, h);
}

/** Lookup the handler registered for an eventId, or undefined. */
export function getWorldEventHandler(eventId: string): WorldEventHandler | undefined {
  return handlers.get(eventId);
}
